import { Container, Dialog, Grid, Typography } from '@material-ui/core';
import { useRouter } from 'next/router';
import React, { useContext } from 'react';
import { Banner } from '../../components/AgentResources/Login';
import { MessageResetPasswordContent, ResetPasswordForm } from '../../components/AgentResources/Passwords';
import AppContext from '../../components/AppContext';
import { DialogHeader } from '../../components/dialog';
import Layout from '../../components/Layout';
import { SnackbarContext } from '../../components/Snackbar/Context';
import { forgotPassword } from '../../interfaces/password';
import { initFalse } from '../../utils/constants';
import { SnackBarSeverity } from '../../utils/enums';
import { handleFormError } from '../../utils/commonUtils';

function ChangePassword() {
  const title = "Agent Resources";
  const subTitle = "Agent resources like marketing materials, training, sample illustrations, enrollment forms, and more.";
  const props = {
    title,
    page: {
      "title": {
        "blocks": [{
          "key": "9qk7h",
          "text": title,
          "type": "H2",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }], "entityMap": {}
      },
      "subTitle": {
        "blocks": [{
          "key": "fraau",
          "text": subTitle,
          "type": "SUBTITLE1",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }], "entityMap": {}
      },
      "strategyText": {
        "blocks": [{
          "key": "5ovo0",
          "text": "Find Your Strategy",
          "type": "H4",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }], "entityMap": {}
      },
      "strategyDescendantText": {
        "blocks": [{
          "key": "9algj",
          "text": "In less than 2 minutes, find the right strategy for your needs.",
          "type": "BODY2",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }], "entityMap": {}
      },
      "mapDescendantText": {
        "blocks": [{
          "key": "3dvc",
          "text": "Tap a map pin to view agent details or zoom the map out if no agents show up in your immediate area. We may also have additional agents available that are not shown on the map so please call us at 1-800-294-9940 and we can get you in contact with an agent near you.",
          "type": "CAPTION",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }], "entityMap": {}
      },
      "mapTitle": {
        "blocks": [{
          "key": "81m1v",
          "text": "Licensed Agents Map",
          "type": "H2",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }], "entityMap": {}
      },
      "bgImage": "img-hero-agent-lookup.jpg",
      "carouselId": 3
    },
    data: {
      "subTitle": {
        "blocks": [{
          "key": "fraau",
          "text": subTitle,
          "type": "SUBTITLE1",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }], "entityMap": {}
      },
      "registerTitle": {
        "blocks": [{
          "key": "fraau",
          "text": "Need to register?",
          "type": "H4",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }], "entityMap": {}
      },
      "registerText": {
        "blocks": [{
          "key": "fraau",
          "text": "Become an approved agent to access resources.",
          "type": "BODY2",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }], "entityMap": {}
      },
      "preferredTitle": {
        "blocks": [{
          "key": "fraau",
          "text": "Are you an NIW Preferred Agent?",
          "type": "H4",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }], "entityMap": {}
      },
      "preferredText": {
        "blocks": [{
          "key": "fraau",
          "text": "Preferred agents have access to ilia, NIW's robust client management and enrollment portal for Kai-Zen",
          "type": "BODY2",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }], "entityMap": {}
      },
    },
    keyword: "agent resources",
    description: "Agent resources like marketing materials, training, sample illustrations, enrollment forms, and more. "
  };


  return (
    <AppContext.Provider value={props.page}>
      <Layout
        title={props.title}
        description={props.data.subTitle}
        keyword={props.keyword}
        pageDescription={props.description}
      >
        <ForgotPassword title={props.page.title} {...props.data}/>
      </Layout>
    </AppContext.Provider>
  );
}

const ForgotPassword = ({title, subTitle}: any) => {
  const router = useRouter();
  const snackbar = useContext(SnackbarContext);

  const [showDialog, setShowDialog] = React.useState(initFalse);

  const submit = async (values: any, {setSubmitting}: any) => {
    try {
      const res = await forgotPassword(values);
      snackbar.showMessage(res.data, SnackBarSeverity.Success);
      setShowDialog(!initFalse);
    } catch (e: any) {
      const errMessage = handleFormError(e);
      snackbar.showMessage(errMessage, SnackBarSeverity.Error);
    } finally {
      setSubmitting(initFalse);
    }
  }

  const handleClose = () => {
    setShowDialog(initFalse);
    router.push("/agent-resources").then();
  }

  return (
    <>
      <Banner title={title} subTitle={subTitle}/>
      <div className="sectionPD">
        <Container maxWidth="lg">
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} md={6}>
              <Typography color="primary" component="strong" className="f28 mb20 floatLeft w100">
                Forgot Password?
              </Typography>
              <Typography style={{marginBottom: "20px"}}>
                Enter your email to receive a link to reset your password. Please
                email <a href="mailto:niw.selling@simplicitygroup.com"
                         style={{textDecoration: "underline"}}>niw.selling@simplicitygroup.com</a> if
                you are having trouble.
              </Typography>
              <ResetPasswordForm submit={submit}/>
            </Grid>
          </Grid>
        </Container>
      </div>
      <MessageResetPasswordDialog open={showDialog} handleClose={handleClose} title={"Reset Password Link Sent"}/>
    </>
  )
}

type DialogPasswordProps = {
  open: boolean;
  handleClose: () => void;
  title: string
}

const MessageResetPasswordDialog = ({open, handleClose, title}: DialogPasswordProps) => {
  return (
    <Dialog open={open}>
      <DialogHeader onClose={handleClose}>
        {title}
      </DialogHeader>
      <MessageResetPasswordContent handleClose={handleClose}/>
    </Dialog>
  )
}

export default ChangePassword

